module.exports = __webpack_public_path__ + "img/SKMJ_etc5.7d8f3c25.jpg";